import { Action, Dispatch } from 'redux'
import { initCalendarAction } from 'reducks/calendar/actions'

const initCalendar = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initCalendarAction())
  }
}

export default initCalendar
